<template>
  <div class="row card animated zoomIn">
    <div class="col s12 m6">
      <h5>iRecharge API</h5>
      <p class="text-justify">
The iRecharge API is a white label solution available for businesses to integrate into their websites, mobile
applications and other digital platforms to help them create alternative income channels. With our
services plugged into your platforms, you would earn commissions on every completed transaction.Our
team of highly skilled software developers are available to help through the integration process.
Join other businesses and financial institutions who are currently using our API to make their businesses
better!
      </p>
      <h5>Benefits</h5>
      <ul>
        <li>
        New revenue chanel for your business.
        </li>
        <li>
        Ease of Integration – Our API documentation is well detailed and easy to comprehend.
        </li>
        <li>Our customer support is available 24/7 from sign up to post-integration.</li>
        <li>It doesn’t interfere with the actual structure of your business.</li>
        <li>It helps grow your website traffic and is a value added service for your customers.</li>
        <li>A physical business location is not required.</li>
      </ul>
      <p>
        Need more information? call us on 08070791359, 07085626007
      </p>
      <p><strong>OR</strong></p>
     <button class="btn-large waves-effect green darken-2 waves-dark" style="width:100%;" @click="openPage()">Get Started</button>
    </div>
    <solution-part />
  </div>
</template>
<script>
import SolutionPart from '@/components/partials/SolutionPart.vue'
export default {
  name: 'iRechargeApi',
  components: {
    SolutionPart
  },
  mounted() {
    this.startCarousel()
  },
  data() {
    return {}
  },
  methods: {
    startCarousel() {
      var owlClients = $('#owlClients')
      owlClients.owlCarousel({
        items: 2,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 1000,
        autoplayHoverPause: true
      })
      var owlTestimonial = $('#owlTestimonial')
      owlTestimonial.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
      })
      
    },
    openPage() {
      document.getElementById('myNav').style.width = '100%'
      this.$emit('modal-option', 'signup')
    }
  }
}
</script>
<style scoped>
ul li {
  list-style-type: circle;
  text-align: left;
}
.card {
  padding: 15px 20px;
}
</style>
